var convert = require('./convert'),
    func = convert('getOr', require('../get'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/fp/getOr.js
// module id = 96
// module chunks = 53243946022428 164721891013254 277786696673472